import http from './http';

export default {
  // 获取试卷列表 - 通过ExamController
  getList(params) {
    return http.get('/o1/exam_controller/papers', params);
  },

  // 获取试卷详情
  getDetail(id) {
    return http.get('/o1/exam_controller/paper_detail', { id });
  },

  // 预览试卷
  preview(params) {
    return http.get('/o1/exam_controller/paper_detail', params);
  },

  // 创建试卷
  create(data) {
    return http.post('/o1/exam_controller/save_paper', data);
  },

  // 更新试卷
  update(id, data) {
    return http.post('/o1/exam_controller/save_paper', { id, ...data });
  },

  // 删除试卷
  delete(id) {
    return http.post('/o1/exam_controller/delete_paper', { id });
  },

  // 批量删除试卷
  batchDelete(ids) {
    return http.post('/o1/paper_controller/batch_delete', { ids });
  },

  // 复制试卷
  copy(id) {
    return http.post('/o1/paper_controller/copy', { id });
  },

  // 发布试卷
  publish(id) {
    return http.post('/o1/paper_controller/publish', { id });
  },

  // 归档试卷
  archive(id) {
    return http.post('/o1/paper_controller/archive', { id });
  },

  // 获取试卷题目
  getQuestions(id) {
    return http.get('/o1/exam_controller/questions', { id });
  },

  // 删除试卷题目
  deleteQuestion(paperId, questionId) {
    return http.post('/o1/exam_controller/delete_question', { 
      paper_id: paperId, 
      question_id: questionId 
    });
  },

  // 更新试卷题目分值
  updateQuestionScore(paperId, questionId, score) {
    return http.post('/o1/exam_controller/update_question_score', { 
      paper_id: paperId, 
      question_id: questionId, 
      score: score 
    });
  },

  // 更新试卷题目内容
  updateQuestion(paperId, questionId, questionData) {
    return http.post('/o1/exam_controller/update_question', { 
      paper_id: paperId, 
      question_id: questionId,
      ...questionData
    });
  },

  // 更新试卷题目
  updateQuestions(id, questions) {
    return http.post('/o1/exam_controller/update_questions', { id, questions });
  },

  // 获取科目选项
  getSubjectOptions() {
    return http.get('/o1/paper_controller/get_subject_options');
  },

  // 获取状态选项
  getStatusOptions() {
    return http.get('/o1/paper_controller/get_status_options');
  },

  // 获取难度选项
  getDifficultyOptions() {
    return http.get('/o1/paper_controller/get_difficulty_options');
  },

  // 获取打乱类型选项
  getShuffleTypeOptions() {
    return http.get('/o1/paper_controller/get_shuffle_type_options');
  },

  // 获取试卷统计
  getStatistics() {
    return http.get('/o1/paper_controller/statistics');
  },

  // 获取试卷题目统计
  getQuestionStats(paperId) {
    return http.get('/o1/paper_controller/question_stats', { paper_id: paperId });
  },

  // 大题管理相关接口
  // 获取试卷的所有大题
  getSections(paperId) {
    return http.get('/o1/section_controller/index', { paper_id: paperId });
  },

  // 获取大题详情
  getSectionDetail(sectionId) {
    return http.get('/o1/section_controller/read', { id: sectionId });
  },

  // 创建大题
  createSection(data) {
    return http.post('/o1/section_controller/save', data);
  },

  // 更新大题
  updateSection(data) {
    return http.post('/o1/section_controller/update', data);
  },

  // 删除大题
  deleteSection(sectionId) {
    return http.post('/o1/section_controller/delete', { id: sectionId });
  },

  // 批量删除大题
  batchDeleteSections(ids) {
    return http.post('/o1/section_controller/batchDelete', { ids });
  },

  // 更新大题排序
  updateSectionSort(paperId, sortData) {
    return http.post('/o1/section_controller/updateSort', { 
      paper_id: paperId, 
      sort_data: sortData 
    });
  },

  // 获取大题下的题目列表
  getSectionQuestions(sectionId) {
    return http.get('/o1/section_controller/getQuestions', { section_id: sectionId });
  },

  // 移动题目到指定大题
  moveQuestionToSection(questionId, targetSectionId) {
    return http.post('/o1/section_controller/moveQuestion', { 
      question_id: questionId, 
      target_section_id: targetSectionId 
    });
  },

  // 重新计算大题统计
  recalculateSectionStats(sectionId) {
    return http.post('/o1/section_controller/recalculateStats', { section_id: sectionId });
  }
};
